import { List, ListItemButton, ListItemText, ListItemIcon, useTheme, Menu, MenuItem } from "@mui/material";
import React, { useState } from "react"
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useFamilyNameList } from "../../fetch/fetchClassificationItems";

export default function FaultItemFamilyCell({ fault }) {
    const { familyNames } = fault;
    const { familyNames: sourceFamilyNames } = useFamilyNameList(true);
    const theme = useTheme();
    const location = useLocation();
    const navigate = useNavigate();
    const { familyNameId } = useParams();
    const [anchorEl, setAnchorEl] = useState(null);
    const open = !!anchorEl;

    const handleClickListItem = (event) => {
        event.stopPropagation();
        setAnchorEl(event.currentTarget);
    };

    const handleMenuItemClick = (event, familyNameId) => {
        event.stopPropagation();
        setAnchorEl(null);

        const params = new URLSearchParams(location.search);
        let navigateUrl = `/literature/fault/${familyNameId}/?${params.toString()}${window.location.hash}`;
        if (familyNameId === null) {
            navigateUrl = `/literature/fault/?${params.toString()}${window.location.hash}`;
        }
        navigate(navigateUrl);
    };

    const handleClose = (event) => {
        event.stopPropagation();
        setAnchorEl(null);
    };

    const selectedFamily = familyNames.filter(it => it.id == familyNameId)[0];

    const matchedFamilies = sourceFamilyNames.filter(it => familyNames.indexOf(it.name) >= 0);

    let matchCount = familyNames.length;
    let familyNameText = `${familyNames.length} Families`;
    if (familyNames.length === 1) {
        matchCount = 1;
        familyNameText = familyNames[0];
    } else if (familyNames.length > 1) {
        familyNameText = `${familyNames.length} Families`
    }

    if (matchCount <= 1) {
        return <span>{familyNameText}</span>
    }


    return (
        <>
            <List>
                <ListItemButton
                    id='fault-family-button'
                    aria-haspopup="listbox"
                    aria-controls="fault-family-menu"
                    aria-label="fault family"
                    aria-expanded={open ? 'true' : undefined}
                    onClick={handleClickListItem}
                    style={{
                        padding: '2px 4px 2px 16px',
                        background: theme.palette.primary.main,
                        color: theme.palette.primary.contrastText,
                        borderRadius: theme.shape.borderRadius,
                        boxShadow: theme.shadows[2]
                    }}
                >
                    <ListItemText
                        primary={familyNameText}
                        style={{ textWrap: 'nowrap' }}
                    />
                    <ListItemIcon style={{ minWidth: 32 }}>
                        <KeyboardArrowDownIcon style={{ color: theme.palette.primary.contrastText }} />
                    </ListItemIcon>
                </ListItemButton>
            </List>
            <Menu
                id="fault-family-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                    'aria-labelledby': 'fault-family-button',
                    role: 'listbox',
                }}
            >
                {matchedFamilies.map((familyName) => (
                    <MenuItem
                        key={familyName.id}
                        selected={familyName.id === selectedFamily?.id}
                        onClick={(event) => handleMenuItemClick(event, familyName.id)}
                    >
                        {familyName.name}
                    </MenuItem>
                ))}
            </Menu>
        </>
    );
}